import Cocktail from "./cocktail"
const Home =()=>{
    

    console.log()
    return (
        <>
        <main>
              <Cocktail></Cocktail>
                
        </main>
        </>
    )
}

export default Home